import { render, staticRenderFns } from "./Control.vue?vue&type=template&id=19ca8148&scoped=true&"
import script from "./Control.js?vue&type=script&lang=js&"
export * from "./Control.js?vue&type=script&lang=js&"
import style0 from "./Control.scss?vue&type=style&index=0&id=19ca8148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ca8148",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
